import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    token: localStorage.getItem('token') || ''
  },
  mutations: {
    SET_USER (state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SET_TOKEN (state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    CLEAR_AUTH (state) {
      state.user = null
      state.token = ''
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  },
  actions: {
    setUser ({ commit }, user) {
      commit('SET_USER', user)
    },
    setToken ({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    logout ({ commit }) {
      commit('CLEAR_AUTH')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    user: state => state.user,
    isAdmin: state => state.user?.role === 'admin'
  }
})
